import { CbShadowSubtle } from '@coolblue-development/design-tokens';
export const getIconStyles = ({ checked, spacing, }, theme) => ({
    position: 'absolute',
    marginTop: '2px',
    left: spacing === 'default' ? theme.spacing[400] : theme.spacing[200],
    top: spacing === 'default' ? theme.spacing[400] : theme.spacing[200],
    /*
     * When checked, the position of the element needs to be reduced by 1px to compensate
     * for the border width increase.
     */
    ...(checked && {
        left: spacing === 'default' ? '1.5rem' : '.7rem',
        top: spacing === 'default' ? '1.5rem' : '.7rem',
    }),
    '& svg': {
        verticalAlign: 'top',
    },
});
export const getInputStyles = (theme) => ({
    clipPath: 'circle(0)',
    position: 'absolute',
    '&:focus-visible ~ label': {
        boxShadow: `0 0 0 2px ${theme.color.border.interactiveFocusedInner}, 0 0 0 4px ${theme.color.border.interactiveFocused} !important`,
    },
});
export const getSelectableBoxContainerStyles = () => ({
    position: 'relative',
    display: 'contents',
});
export const getSelectableBoxStyles = ({ checked, disabled, inputPlacement, spacing, }, theme) => ({
    borderRadius: theme.spacing[100],
    border: `1px solid ${theme.color.border.interactiveBase}`,
    position: 'relative',
    display: 'grid',
    cursor: 'pointer',
    boxSizing: 'border-box',
    transition: 'background-color 0.1s ease-in, border-color 0.1s ease-in, box-shadow 0.2s ease-in, outline-color 0.1s ease-in',
    '&:hover:not(:active)': {
        boxShadow: CbShadowSubtle,
    },
    ...(inputPlacement === 'left'
        ? {
            padding: {
                default: `${theme.spacing[400]} ${theme.spacing[400]} ${theme.spacing[400]} ${theme.spacing[1100]}`,
                compact: `${theme.spacing[200]} ${theme.spacing[300]} ${theme.spacing[200]} ${theme.spacing[800]}`,
                compactSquare: `${theme.spacing[200]} ${theme.spacing[200]} ${theme.spacing[200]} ${theme.spacing[700]}`,
            }[spacing || 'default'],
        }
        : {
            padding: {
                default: theme.spacing[400],
                compact: `${theme.spacing[200]} ${theme.spacing[300]}`,
                compactSquare: theme.spacing[200],
            }[spacing || 'default'],
        }),
    ...(checked && {
        borderColor: theme.color.border.interactiveSelected,
        backgroundColor: theme.color.background.interactiveSelected,
        borderWidth: `2px`,
        /*
         * When checked, the padding of the element needs to be reduced by 1px to compensate
         * for the border width increase.
         */
        ...(inputPlacement === 'left'
            ? {
                padding: {
                    default: '1.5rem 1.5rem 1.5rem 4.3rem',
                    compact: '.7rem 1.1rem .7rem 3.1rem',
                    compactSquare: '.7rem .7rem .7rem 2.7rem',
                }[spacing || 'default'],
            }
            : {
                padding: {
                    default: '1.5rem',
                    compact: '.7rem 1.1rem',
                    compactSquare: '.7rem',
                }[spacing || 'default'],
            }),
    }),
    ...(disabled && {
        backgroundColor: theme.color.background.interactiveDisabled,
        outlineColor: theme.color.border.interactiveDisabled,
        cursor: 'unset',
        '&:before': {
            borderRadius: theme.spacing[100],
            content: '""',
            position: 'absolute',
            left: '-1px',
            top: '-1px',
            width: 'calc(100% + 2px)',
            height: 'calc(100% + 2px)',
            backgroundColor: theme.color.background.interactiveDisabled,
            opacity: 0.5,
            zIndex: 1,
        },
        '&:hover:not(:active)': {
            boxShadow: theme.shadow.none,
        },
    }),
});
//# sourceMappingURL=SelectableBox.styles.js.map